module.exports = __webpack_public_path__ + "img/hello-img-sponsor-licence.22e91e32.png";